export function createError(errorMessage: string, title?: string) {
  const error = new Error(errorMessage);
  if (title) {
    error.name = title;
  }

  return error;
}
